// Recalculate price when variant is switched
document.addEventListener('DOMContentLoaded', function () {
  const priceElement = document.querySelector('.price__current'); // Price
  const comparePriceElement = document.querySelector('.price__compare-at'); // Compare Price
  const howdyPriceJsonElement = document.querySelector('#howdy-price-json'); // Howdy Price JSON
  const howdyPriceJson = JSON.parse(howdyPriceJsonElement.textContent);
  const maxDiscountPercent = howdyPriceJson.maxDiscountPercent;

  if(maxDiscountPercent > 0){
    // MutationObserver callback function
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'childList') {

          // Get variant Id
          const variantSelectionElement = document.querySelector('variant-selection.variant-selection');
          const variantId = variantSelectionElement.variant;
          // console.log("variantSelectionElement", variantSelectionElement);
          // console.log("variantId", variantId);

          let newPrice = "";
          let newComparePrice = "";

          if(variantId){
            // Price processing
            // const howdyPriceJson = JSON.parse(howdyPriceJsonElement.textContent);
            // console.log("howdyPriceJson", howdyPriceJson);
            // console.log("howdyPriceJson.variants", howdyPriceJson.variants);

            const variant = howdyPriceJson.variants.find(variant => variant.id === variantId);
            // console.log("variant", variant);

            if(variant){
              newPrice = variant.howdy_price;
              newComparePrice = variant.howdy_compare_price;
            }
          }
          
          // Pause
          observer.disconnect();
          
          if(newPrice != ""){
            // Display new price
            priceElement.innerHTML = newPrice;
            comparePriceElement.innerHTML = newComparePrice;
            comparePriceElement.classList.add("visible");
          }

          // Start monitoring again
          observer.observe(priceElement, config);
        }
      });
    });

    // Monitoring settings
    const config = { childList: true, subtree: false }; // Monitor changes to child elements
    // Start monitoring
    observer.observe(priceElement, config);
  }
});